import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.ts";

import { useEappStore } from "#src/stores/electronic-application.ts";
import { useStepQuoteStore } from "#src/stores/step-quote.ts";
import { useStepLifePriorityStore } from "#src/stores/step-life-priority.ts";
import { useStepBirthdateStore } from "#src/stores/step-birthdate.ts";
import { type BaseStepStore } from "#src/types/StepStore.ts";
import { computed, type ComputedRef } from "vue";
import { type StoreGeneric, type Pinia } from "pinia";

interface PreQuoteInformationStep extends BaseStepStore {
  inactive: ComputedRef<boolean>;
}

function initializePreQuoteInformationStore(
  pinia: Pinia
): PreQuoteInformationStep {
  const step = computed(() => STEP.PRE_QUOTE_INFORMATION_STEP);
  const next = computed(() => {
    const quote = useStepQuoteStore(pinia);
    return quote.step;
  });
  const previous = computed(() => {
    const birthdate = useStepBirthdateStore(pinia);
    if (birthdate.next === step.value) {
      if (birthdate.inactive) return birthdate.previous;
      return birthdate.step;
    }

    const priority = useStepLifePriorityStore(pinia);
    return priority.step;
  });
  const inactive = computed(() => {
    const birthdate = useStepBirthdateStore(pinia);
    if (birthdate.next === step.value) return false;
    const eAppStore = useEappStore(pinia);
    return eAppStore.assistance.topPriority !== "income_rider";
  });

  function $reset() {}

  return {
    $reset,
    step,
    next,
    previous,
    inactive,
  };
}

export const useStepPreQuoteInformationStore = (
  pinia: Pinia,
  hot?: StoreGeneric
) => {
  return defineStore<string, PreQuoteInformationStep>(
    "step-pre-quote-information",
    () => {
      return initializePreQuoteInformationStore(pinia);
    }
  )(pinia, hot);
};
